/* eslint-disable react/prop-types */
import { Content as CarbonContent } from '@carbon/react';

export const Content = ({ children, ...props }) => (
  <CarbonContent {...props}>{children}</CarbonContent>
);
